import styled from "@emotion/styled";

import SelectList from "metabase/components/SelectList";

export const StyledSelectList = styled(SelectList)`
  width: 100%;
  padding: 0 1rem;
`;
